/* import __COLOCATED_TEMPLATE__ from './horizontal-divider.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();